<template xmlns="http://www.w3.org/1999/html">
    <b-modal v-model="visible" size="lg">
        <template v-slot:modal-header="{ close }">
            <div class="row" style="width: 100%">
                <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                    <h3> {{
                            analyzeType == 'sell' ? __('store_sell_analyze_as_pattern_modal_header') : __('store_buy_analyze_as_pattern_modal_header')
                        }}
                        <button-open-help-modal :color="'dark'" :in-extra-div="false"
                                                :helpName="analyzeType == 'sell'? 'ASB-011' : 'ASA-011'"/>
                    </h3>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" v-on:click="visible = false">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">{{ __('close') }}</span>
                    </button>
                </div>
            </div>
        </template>

        <template v-slot:default="{}" class="modal-body">
            <div v-if="displayFirstInfoRow">
                <p>{{ __("first_info_row_in_store_analyze_pattern") }}</p>
                <ul>
                    <li v-if="displayFirstItemInFirstInfoRow">{{ __('first_item_row_in_store_analyze_pattern') }}</li>
                    <li v-if="displaySecondItemInFirstInfoRow">{{ __('second_item_row_in_store_analyze_pattern') }}</li>
                </ul>
            </div>
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <h5 v-html="__('choose_date_to_in_store_analyze_pattern')"></h5>
                    <label class="d-block mt-1">
                        <input type="radio" value="current_date" v-model="storeAnalyzePatternModel.date_to_type">
                        {{ __('always_current_date') }}
                    </label>
                    <label class="d-block">
                        <input type="radio" :value="dateTo" v-model="storeAnalyzePatternModel.date_to_type">
                        {{ dateTo }}
                    </label>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div
                            class="col-md-6 col-sm-6 mt-2"
                            :class="hasError('name') ? 'has-error' : ''"
                        >
                            <h5>{{ __('fill_data_for_saved_pattern') }}</h5>
                            <input-wrapper
                                :label="
                            __(
                                'patter_name'
                            ) + '*'
                        "
                                labelClass="text-bold"
                                type="text"
                                classNames="form-control"
                                v-model="storeAnalyzePatternModel.name"
                                :errors="getErrors('name')"
                            />
                        </div>
                        <div class="col-6 " style="margin-top: 3.7rem !important;">
                            <label class="d-block">
                                <input type="checkbox" v-model="storeAnalyzePatternModel.is_private">
                                {{ __('sb_analyze_pattern_is_private') }}
                            </label>
                        </div>
                    </div>
                </div>

            </div>
        </template>
        <template v-slot:modal-footer="{}">
            <div class="d-flex justify-content-between w-100">
                <!-- Pierwszy przycisk po lewej -->
                <div class="white-space-no-wrap">
                    <button type="button" class="btn btn-primary" @click="showModalParamsPattern">
                        {{ __('sb_analyze_show_params_pattern') }}
                    </button>
                </div>

                <!-- Pozostałe przyciski po prawej -->
                <div class="d-flex gap-3">
                    <button type="button" class="btn btn-white" v-on:click="visible = false">
                        {{ __('cancel') }}
                    </button>
                    <button type="button" class="btn btn-primary ml-2" @click="submitForm">
                        {{ __('save') }}
                    </button>
                </div>
            </div>
        </template>


    </b-modal>
</template>

<script>
import {storeAnalyzePatternModel} from "../../modules/store-analyze-pattern-helpers";
import InputWrapper from "../../components/form/InputWrapper.vue";
import hasErrors from "../../mixins/hasErrors";
import axios from "axios";

export default {
    mixins: [hasErrors],
    name: "StoreAnalyzePattern",
    components: {InputWrapper},
    data: function () {
        return {
            visible: false,
            // storeAnalyzePatternModel: storeAnalyzePatternModel()
        }
    },
    props: {
        storeAnalyzePatternModel:{
            type:Object,
            default: () => (storeAnalyzePatternModel())
        },
        analyzeType: {
            type: String
        },
        searchValue: {
            type: String,
            default: '',
        },
        filterSelectedCheckbox: {
            type: Boolean,
            default: false,
        },
        correction: {
            type: Number,
            default: 0,
        },
        dateTo: {
            type: String
        },
        dateType: {
            type: String
        },
        dateFrom: {
            type: String
        },
        analyzeLevel: {
            type: Object,
            default: {
                analyze_level_1: null,
                analyze_level_2: null,
                analyze_level_3: null,

            }
        },
        chartData: {
            type: Object,
        },
        globalFilters: {
            type: Object,
        },
        selectedColumns: {
            type: Array,
        },
        itemGroups:{
            type: Array,
            default:[]
        },
        contractorGroups:{
            type: Array,
            default:[]
        }
    },
    methods: {
        async submitForm() {
            try {
                const response = await axios.post("/analyze/sb-analyze-saved-patterns", this.extendedAnalyzePatternModel)
                if (response.data.success) {

                    this.visible = false; // Zamknij modal
                    this.storeAnalyzePatternModel = storeAnalyzePatternModel()
                    toastr['success'](this.__(response.data.message)).css('border', '0px')
                }
                else{
                    toastr['error'](this.__('failed_to_perform_action')).css('border', '0px');
                }
            } catch (error) {
                if (error.response && error.response.status === 422) {
                    this.errors = error.response.data.errors; // Obsługa walidacji Laravel
                }
            }
        },
        async showModalParamsPattern(){
            try {
                const response = await axios.post("/analyze/show-sb-analyze-pattern-params", this.extendedAnalyzePatternModel)
                if (response.data.success) {
                    $('#saved-analyze-pattern-params-modal-title').text(response.data.title)
                    $('#saved-analyze-pattern-params-modal-body').html(response.data.html)
                    $('#saved-analyze-pattern-params').modal('show')
                }
                else{
                    toastr['error'](this.__('failed_to_perform_action')).css('border', '0px');
                }
            } catch (error) {
                if (error.response && error.response.status === 422) {
                    this.errors = error.response.data.errors; // Obsługa walidacji Laravel
                }
            }

        },
    },
    computed: {
        displayFirstInfoRow: function () {
            return this.displayFirstItemInFirstInfoRow || this.displaySecondItemInFirstInfoRow;
        },
        displayFirstItemInFirstInfoRow: function () {
            return this.searchValue !== '' && this.searchValue !== null;
        },
        displaySecondItemInFirstInfoRow: function () {
            return this.filterSelectedCheckbox;
        },
        extendedAnalyzePatternModel() {
            return {
                ...this.storeAnalyzePatternModel,
                buy_or_sell: this.analyzeType,
                date_type: this.dateType,
                date_from: this.dateFrom,
                date_to: this.storeAnalyzePatternModel.date_to_type === 'current_date' ? null : this.dateTo,
                correction: this.correction,
                ...this.analyzeLevel,
                chart_crit_1: this.chartData.crit_1,
                chart_crit_2: this.chartData.crit_2,
                chart_crit_3: this.chartData.crit_3,
                chart_name: this.chartData.name,
                global_filters: this.globalFilters,
                columns: this.selectedColumns,
                item_groups: this.itemGroups,
                contractor_groups:this.contractorGroups

            };
        }
    }
}
</script>

<style scoped>

</style>
